import { ChronoUnitLegacy } from "utils/time-utils";
import { LabelLayer, ScadaProps, ScadaLabel, ParentRect } from "../scadaTypes";

export const DEFAULT_LAYER_NAME = 'Default';

export const defaultLayer: LabelLayer = {
	layer: '',
	visible: true
};

export const defaultScadaConfig: ScadaProps = {
	type: 'scada',
	size: 12,
	truncateSize: 10,
	refreshRate: 30,
	maxDelayTime: 1,
	maxDelayTimeUnit: ChronoUnitLegacy.MINUTES,
	showScadaSettings: true,
	elements: [],
	labelLayers: [{
		layer: DEFAULT_LAYER_NAME,
		visible: true
	}]
};

export const defaultLabel: ScadaLabel = {
	identifier: '',
	xCoord: 0,
	yCoord: 0,
	fontSize: 10,
	bgColor: '#f5f5f5',
	type: 'LABEL',
	layer: DEFAULT_LAYER_NAME
}

export const defaultElementParameters: ParentRect = {
	width: 0,
	height: 0,
	top: 0,
	left: 0,
};

export const defaultDateTime = {
	date: new Date(),
	manualTime: false,
};